/* @flow */
import Entity from 'lib/Entity';
import GroupClusterItems from 'collections/GroupClusterItems';
import { cloneDeep } from 'lodash';

export default class OrganizationProfileTeacher extends Entity {
  parse(response: Object) {
    const teacher = cloneDeep(response);
    teacher['owned_groups'] = GroupClusterItems.fromJSON(teacher['owned_groups']);
    return teacher;
  }

  getSignature() {
    return this.get('signature');
  }

// $FlowFixMe
  get groupClusterItems() {
    return this.get('owned_groups');
  }
}



// WEBPACK FOOTER //
// ./src/entities/OrganizationProfileTeacher.js